import rg4js from 'raygun4js';
import { createRoot } from 'react-dom/client';
import { App } from './app/App';
import './setup';
import { isDevelopment } from '@diana/env-ui';

const container = document.getElementById('root')!;
const root = createRoot(container);
root.render(<App />);

if ('serviceWorker' in navigator) {
  window.addEventListener('load', loadServiceWorker);
}

async function loadServiceWorker() {
  // Unregister all service workers in development mode
  if (isDevelopment()) {
    navigator.serviceWorker.getRegistrations().then((registrations) => {
      registrations.forEach((registration) => {
        registration.unregister();
      });
    });

    return;
  }

  // Register service worker in all other environments
  const serviceWorkerUrl = '/serviceworker.js';
  console.log(`[ServiceWorker]: Loading service worker: ${serviceWorkerUrl}`);
  navigator.serviceWorker
    .register(serviceWorkerUrl, { scope: '/' })
    .then((reg) => {
      console.log(`[ServiceWorker]: Successfully connected to service worker: ${reg.scope}`);
    })
    .catch((err) => {
      console.error(`[ServiceWorker]: Failure during service worker connection: ${err}`);
      rg4js('send', err);
    });
}
